import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  TELEPHONY_DIRECTORY_EDIT,
  TELEPHONY_DIRECTORY_ICON_OPTIONS,
} from '../../../../../constants/ServiceConstants';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_TELEPHONY,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import { telephonyDirectoriesSelector } from '../../../servicesSlice';

const DirecoryView = (props) => {
  const { onViewToggle, onDrawerToggle, directoriesObj, permissions } = props;
  const [directory, setDirectory] = useState(null);
  const directories = useSelector(telephonyDirectoriesSelector);

  useEffect(() => {
    if (directories.length) {
      let directoryObj = directories.find((directory) => directory.id === directoriesObj.id);
      setDirectory(directoryObj);
    }
  }, [directories]);

  const onClickEdit = (event) => {
    onDrawerToggle(TELEPHONY_DIRECTORY_EDIT, true, directory);
  };

  const getIconSource = (iconName) => {
    const iconObj = TELEPHONY_DIRECTORY_ICON_OPTIONS.find((icon) => icon.name === iconName);
    if (iconObj) return iconObj.url;
    return '';
  };

  const renderScreen = () => {
    return (
      <div className='row mx-4 mt-4'>
        <div className='col-md-6 mt-4'>
          <div className='details-label'>Name</div>
          <div className='details-value preview-breaks'>{directory?.name}</div>
        </div>
        <div className='col-md-6 mt-4'>
          <div className='details-label'>Number Code</div>
          <div className='details-value'>{directory?.code || '---'}</div>
        </div>
        <div className='col-md-6 mt-4'>
          <div className='details-label'>Extension Number</div>
          <div className='details-value'>{directory?.extensionNumber}</div>
        </div>
        <div className='col-md-6 mt-4'>
          <div className='details-label'>Extension Password</div>
          <div className='details-value'>{directory?.extensionPassword || '---'}</div>
        </div>
        <div className='col-md-6 mt-4'>
          <div className='details-label'>Icon</div>
          <div className='details-value'>
            <img src={getIconSource(directory?.icon)} alt={directory?.icon} />
          </div>
        </div>
        <div className='col-md-6 mt-4'>
          <div className='details-label'>Status</div>
          <div
            className={`${
              directory?.isActive ? 'pill-active' : 'pill-inactive'
            } col-md-3 pill-text pill`}
          >
            <span>{directory?.isActive ? 'Active' : 'Inactive'}</span>
          </div>
        </div>
        <div className='col-md-12 mt-4'>
          <div className='details-label'>Description</div>
          <div className='details-value preview-breaks'>{directory?.description || '---'}</div>
        </div>
      </div>
    );
  };

  const onClickBack = () => {
    onViewToggle(null, false, null);
  };
  return (
    <>
      {directoriesObj && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          onClickBack={onClickBack}
          onViewToggle={onViewToggle}
          title={directory?.name}
          createdUserId={directoriesObj.createdBy}
          isEditable={
            permissions[RBAC_TYPE_SERVICES_TELEPHONY] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
        />
      )}
    </>
  );
};

export default DirecoryView;
